import React from "react";
import { Col, Form, Select } from "antd";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { required } from "../../../../../lib/utils/formValidation";
import {
  AAC_SAMPLE_FORMAT,
  AAC_SAMPLE_RATE,
  MPEG2AUDIO_BITRATE,
  AAC_PROFILE,
} from "../../../../../lib/utils/constants";

const { Item } = Form;
const { Option } = Select;

const AACCodec = ({ fieldPrefix, disabled }) => {
  return (
    <>
      <Col span={8}>
        <Item
          name={[...fieldPrefix, "b"]}
          label={<FormattedMessage id="Mpeg2AudioCodec.bitrate" defaultMessage="Bitrate" />}
          rules={[required]}
        >
          <Select disabled={disabled}>
            {MPEG2AUDIO_BITRATE.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Item>
      </Col>
      <Col span={8}>
        <Item
          name={[...fieldPrefix, "sampleFormat"]}
          label={<FormattedMessage id="Mpeg2AudioCodec.sampleFormat" defaultMessage="Sample format" />}
          rules={[required]}
        >
          <Select disabled={disabled}>
            {AAC_SAMPLE_FORMAT.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Item>
      </Col>
      <Col span={8}>
        <Item
          name={[...fieldPrefix, "sampleRate"]}
          label={<FormattedMessage id="Mpeg2AudioCodec.sampleRate" defaultMessage="Sample rate" />}
          rules={[required]}
        >
          <Select disabled={disabled}>
            {AAC_SAMPLE_RATE.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Item>
      </Col>
      <Col span={8}>
        <Item
          name={[...fieldPrefix, "aacProfile"]}
          label={<FormattedMessage id="Mpeg2AudioCodec.profile" defaultMessage="Profile" />}
          rules={[required]}
        >
          <Select disabled={disabled}>
            {AAC_PROFILE.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Item>
      </Col>
    </>
  );
};

AACCodec.propTypes = {
  disabled: PropTypes.bool.isRequired,
  fieldPrefix: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
};

export default AACCodec;
